// extracted by mini-css-extract-plugin
export default {"header":"P6VlZV","editable":"r_dih7","title":"YRJ7Zv","subtitle":"CaPO9W","filled":"dyFHl1","expanded":"cl3Zhy","arrow":"app11b","details":"m7XSXz"};